import { Job, Job$Type } from '@/types/Job';
import { JOBS_PING_TIMEOUT } from '@/pages/admin/job-pulling-manager';
import MediaRepository from '@/repositories/media-repository';
import { MyMedia, SinglePlayableMedia } from '@Ravnur-Inc/shared/types/Media';
import { $processException } from '@/helpers/error-handler';
import { Vue } from 'vue-class-component';

const repository = new MediaRepository();

let jobsPollingTimeoutId: Nullable<NodeJS.Timeout> = null;

const clearTimeoutIfExists = () => {
  if (jobsPollingTimeoutId) {
    clearTimeout(jobsPollingTimeoutId);
  }
};

class MediaJobsPollingMixin extends Vue {
  protected mediaJob: Nullable<Job> = null;

  protected async pollMediaJobs(media: SinglePlayableMedia | MyMedia) {
    clearTimeoutIfExists();

    try {
      const list = await repository.getAudioIndexingJobs(media.id);
      const job = list
        .filter((j) => j.mediaId === media.id && j.type === Job$Type.AUDIO_INDEXING)
        .pop();

      if (!job) {
        return;
      }

      this.mediaJob = job;
    } catch (e) {
      $processException(e);
    }

    jobsPollingTimeoutId = setTimeout(this.pollMediaJobs.bind(this, media), JOBS_PING_TIMEOUT);
  }

  beforeUnmount() {
    clearTimeoutIfExists();
  }
}

export default MediaJobsPollingMixin;
